import { render } from "./QuestionsAnswersChallenge.vue?vue&type=template&id=8220c432"
import script from "./QuestionsAnswersChallenge.vue?vue&type=script&lang=js"
export * from "./QuestionsAnswersChallenge.vue?vue&type=script&lang=js"

import "./QuestionsAnswersChallenge.vue?vue&type=style&index=0&id=8220c432&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__